/* SNODIS Virtual Try-On – talks to the shop's own tryon.php (the OpenAI key lives only there) */
(function () {
  var dlg = document.querySelector('[data-sn-tryon]');
  var openBtn = document.querySelector('[data-sn-tryon-open]');
  if (!dlg || !openBtn || dlg.dataset.ready) return;
  dlg.dataset.ready = '1';

  var data = JSON.parse(dlg.querySelector('[data-tryon-json]').textContent);
  var $ = function (s) { return dlg.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(dlg.querySelectorAll(s)); };
  var money = function (c) { return (c / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); };

  var photo = null;        // resized Blob
  var photoUrl = null;     // object URL for "before"
  var resultUrl = null;
  var color = null, size = null;
  var tsToken = '';
  var remaining = null;    // tries left today for this visitor (from the server)

  /* ---------- availability: button stays hidden unless the server says the service is up ---------- */
  var wrap = document.querySelector('[data-sn-tryon-wrap]');
  function setRemaining(n, limit) {
    if (typeof n !== 'number') return;
    remaining = n;
    var el = $('[data-tryon-left]');
    if (el) {
      el.hidden = false;
      el.textContent = n > 0
        ? 'Noch ' + n + (limit ? ' von ' + limit : '') + (n === 1 ? ' Anprobe' : ' Anproben') + ' heute'
        : 'Du hast deine Anproben für heute aufgebraucht – morgen geht es weiter!';
      el.classList.toggle('is-empty', n === 0);
    }
    validate();
  }
  fetch(dlg.dataset.endpoint + (dlg.dataset.endpoint.indexOf('?') > -1 ? '&' : '?') + 'status=1', { method: 'GET', cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      if (!j.ok || !j.available) return;       // budget used up, OpenAI credit empty or server down -> keep hidden
      if (wrap) wrap.hidden = false;
      setRemaining(j.remaining, j.limit);
    })
    .catch(function () { /* server unreachable -> keep hidden */ });

  /* ---------- open / close ---------- */
  function show(step) {
    $$('[data-tryon-step]').forEach(function (el) { el.hidden = el.getAttribute('data-tryon-step') !== step; });
  }
  openBtn.addEventListener('click', function () {
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    document.body.classList.add('sn-tryon-lock');
    initColor();
    loadTurnstile();
  });
  function close() {
    if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    document.body.classList.remove('sn-tryon-lock');
  }
  $('[data-tryon-close]').addEventListener('click', close);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.addEventListener('close', function () { document.body.classList.remove('sn-tryon-lock'); });

  /* ---------- colour: preselect the colour currently chosen on the product page ---------- */
  function currentVariant() {
    var input = document.querySelector('product-form form [name="id"], form[action*="/cart/add"] [name="id"]');
    var id = input && +input.value;
    return data.variants.find(function (v) { return v.id === id; }) || data.variants[0];
  }
  function initColor() {
    if (data.colorIdx < 0) return;
    var cv = currentVariant();
    color = cv.options[data.colorIdx];
    $$('[data-tryon-colors] button').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-val') === color); });
  }
  var colorBox = $('[data-tryon-colors]');
  if (colorBox) colorBox.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    $$('[data-tryon-colors] button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
    color = b.getAttribute('data-val');
  });

  /* ---------- photo: resize in the browser (smaller upload, strips EXIF incl. GPS) ---------- */
  var fileInput = $('[data-tryon-file]');
  fileInput.addEventListener('change', function () {
    var f = fileInput.files && fileInput.files[0];
    if (!f) return;
    err('');
    resize(f, 1536).then(function (blob) {
      photo = blob;
      if (photoUrl) URL.revokeObjectURL(photoUrl);
      photoUrl = URL.createObjectURL(blob);
      var prev = $('[data-tryon-preview]');
      prev.src = photoUrl; prev.hidden = false;
      $('[data-tryon-empty]').hidden = true;
      validate();
    }).catch(function () { err('Dieses Foto konnte nicht gelesen werden. Bitte ein JPG oder PNG wählen.'); });
  });
  function resize(file, max) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var url = URL.createObjectURL(file);
      img.onload = function () {
        var s = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s);
        c.height = Math.round(img.naturalHeight * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { b ? resolve(b) : reject(); }, 'image/jpeg', 0.88);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(); };
      img.src = url;
    });
  }

  var consent = $('[data-tryon-consent]');
  var go = $('[data-tryon-go]');
  consent.addEventListener('change', validate);
  function validate() { if (!go) return; go.disabled = remaining === 0 || !(photo && consent.checked && (!dlg.dataset.turnstile || tsToken)); }
  function err(msg) { var e = $('[data-tryon-error]'); e.textContent = msg; e.hidden = !msg; }

  /* ---------- optional Turnstile ---------- */
  function loadTurnstile() {
    var key = dlg.dataset.turnstile, box = $('[data-tryon-ts]');
    if (!key || !box || box.dataset.done) return;
    box.dataset.done = '1';
    window.snTryonTs = function () {
      window.turnstile.render(box, { sitekey: key, callback: function (t) { tsToken = t; validate(); }, 'expired-callback': function () { tsToken = ''; validate(); } });
    };
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=snTryonTs&render=explicit';
    s.async = true;
    document.head.appendChild(s);
  }

  /* ---------- generate ---------- */
  var loadTimer;
  go.addEventListener('click', function () {
    if (go.disabled) return;
    var v = variantFor(color, null, true);
    var fd = new FormData();
    fd.append('photo', photo, 'photo.jpg');
    fd.append('handle', dlg.dataset.handle);
    fd.append('variant', String(v.id));
    fd.append('consent', '1');
    if (tsToken) fd.append('cf-turnstile-response', tsToken);

    show('loading');
    var msgs = ['Das dauert meist 20–40 Sekunden.', 'Wir passen Stoff, Falten und Licht an …', 'Gleich geschafft …'];
    var i = 0, lt = $('[data-tryon-loadtext]');
    lt.textContent = msgs[0];
    loadTimer = setInterval(function () { i = Math.min(i + 1, msgs.length - 1); lt.textContent = msgs[i]; }, 12000);

    fetch(dlg.dataset.endpoint, { method: 'POST', body: fd })
      .then(function (r) { return r.json().catch(function () { return { ok: false, error: 'Unerwartete Antwort vom Server.' }; }); })
      .then(function (j) {
        clearInterval(loadTimer);
        if (!j.ok) throw new Error(j.error || 'Die Anprobe hat nicht geklappt.');
        resultUrl = j.image;
        setRemaining(j.remaining, null);
        var img = $('[data-tryon-result]');
        img.src = resultUrl;
        $('[data-tryon-download]').href = resultUrl;
        renderSizes();
        show('result');
      })
      .catch(function (e) {
        clearInterval(loadTimer);
        show('upload');
        err(e.message || 'Die Anprobe hat nicht geklappt. Bitte versuch es noch einmal.');
        if (/Tageslimit/.test(e.message || '')) setRemaining(0, null);
        if (/ausgelastet|nicht verfügbar/.test(e.message || '') && wrap) { go.disabled = true; }
        if (window.turnstile && dlg.dataset.turnstile) { tsToken = ''; window.turnstile.reset(); validate(); }
      });
  });

  /* ---------- result: before/after ---------- */
  var cmp = $('[data-tryon-compare]');
  cmp.addEventListener('click', function () {
    var before = cmp.getAttribute('aria-pressed') !== 'true';
    cmp.setAttribute('aria-pressed', before);
    $('[data-tryon-result]').src = before ? photoUrl : resultUrl;
    cmp.textContent = before ? 'Anprobe ansehen' : 'Vorher ansehen';
  });
  $('[data-tryon-again]').addEventListener('click', function () { err(''); show('upload'); });

  /* ---------- result: fullscreen view with tap-to-zoom (no pinch needed) ---------- */
  var lb = document.createElement('div');
  lb.className = 'sn-tryon__lightbox';
  lb.hidden = true;
  lb.innerHTML =
    '<div class="sn-tryon__lb-scroll" data-lb-scroll><img alt="Deine virtuelle Anprobe – vergrößert" data-lb-img></div>' +
    '<button type="button" class="sn-tryon__lb-close" data-lb-close aria-label="Vergrößerung schließen">&times;</button>' +
    '<p class="sn-tryon__lb-hint" data-lb-hint>Tippe ins Bild zum Zoomen</p>';
  $('.sn-tryon__box').appendChild(lb);
  var lbScroll = lb.querySelector('[data-lb-scroll]'), lbImg = lb.querySelector('[data-lb-img]'), lbHint = lb.querySelector('[data-lb-hint]');
  var ZOOM = 2.5, zoomed = false;

  function setZoom(on, x, y) {
    // x/y = tap position relative to the image (0..1); keep that point under the finger
    zoomed = on;
    lb.classList.toggle('is-zoomed', on);
    lbImg.style.width = on ? (ZOOM * 100) + '%' : '';
    lbHint.textContent = on ? 'Ziehen zum Verschieben · Tippen zum Verkleinern' : 'Tippe ins Bild zum Zoomen';
    if (on) {
      requestAnimationFrame(function () {
        lbScroll.scrollLeft = x * lbImg.offsetWidth - lbScroll.clientWidth / 2;
        lbScroll.scrollTop = y * lbImg.offsetHeight - lbScroll.clientHeight / 2;
      });
    }
  }
  function openLightbox() {
    lbImg.src = $('[data-tryon-result]').src;
    setZoom(false);
    lb.hidden = false;
  }
  function closeLightbox() { lb.hidden = true; setZoom(false); }

  // tap vs. drag: only toggle zoom when the finger/mouse did not move (so panning never toggles)
  var down = null;
  lbScroll.addEventListener('pointerdown', function (e) { down = { x: e.clientX, y: e.clientY, sl: lbScroll.scrollLeft, st: lbScroll.scrollTop }; });
  lbScroll.addEventListener('pointerup', function (e) {
    if (!down) return;
    var moved = Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y) > 8 || lbScroll.scrollLeft !== down.sl || lbScroll.scrollTop !== down.st;
    down = null;
    if (moved) return;
    var r = lbImg.getBoundingClientRect();
    setZoom(!zoomed, Math.min(1, Math.max(0, (e.clientX - r.left) / r.width)), Math.min(1, Math.max(0, (e.clientY - r.top) / r.height)));
  });
  // desktop: drag with the mouse to pan while zoomed
  var drag = null;
  lbScroll.addEventListener('mousedown', function (e) { if (zoomed) { drag = { x: e.clientX, y: e.clientY, sl: lbScroll.scrollLeft, st: lbScroll.scrollTop }; e.preventDefault(); } });
  window.addEventListener('mousemove', function (e) { if (!drag) return; lbScroll.scrollLeft = drag.sl - (e.clientX - drag.x); lbScroll.scrollTop = drag.st - (e.clientY - drag.y); });
  window.addEventListener('mouseup', function () { drag = null; });

  $('[data-tryon-zoom]').addEventListener('click', openLightbox);
  $('[data-tryon-result]').addEventListener('click', openLightbox);
  lb.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
  // Escape closes the zoom view first instead of the whole dialog
  dlg.addEventListener('cancel', function (e) { if (!lb.hidden) { e.preventDefault(); closeLightbox(); } });

  /* ---------- size + add to cart ---------- */
  function variantFor(c, s, anyAvailable) {
    return data.variants.find(function (v) {
      return (data.colorIdx < 0 || v.options[data.colorIdx] === c) && (s === null ? (!anyAvailable || v.available) : v.options[data.sizeIdx] === s);
    }) || data.variants[0];
  }
  var atc = $('[data-tryon-atc]');
  function renderSizes() {
    var box = $('[data-tryon-sizes]');
    size = null;
    if (!box) { size = undefined; updateAtc(); return; }
    var seen = [];
    box.innerHTML = data.variants.filter(function (v) {
      return data.colorIdx < 0 || v.options[data.colorIdx] === color;
    }).filter(function (v) {
      var s = v.options[data.sizeIdx];
      if (seen.indexOf(s) > -1) return false;
      seen.push(s); return true;
    }).map(function (v) {
      var s = v.options[data.sizeIdx];
      return '<button type="button" class="sn-tryon__opt" data-val="' + s.replace(/"/g, '&quot;') + '" aria-pressed="false"' + (v.available ? '' : ' disabled') + '>' + s + '</button>';
    }).join('');
    updateAtc();
  }
  var sizeBox = $('[data-tryon-sizes]');
  if (sizeBox) sizeBox.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || b.disabled) return;
    $$('[data-tryon-sizes] button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
    size = b.getAttribute('data-val');
    updateAtc();
  });
  function chosen() {
    if (size === null) return null;
    if (size === undefined) return variantFor(color, null, true);
    return variantFor(color, size);
  }
  function updateAtc() {
    var v = chosen();
    atc.disabled = !(v && v.available);
    atc.textContent = v ? 'In den Warenkorb – ' + money(v.price) : 'Größe wählen';
  }
  atc.addEventListener('click', function () {
    var v = chosen();
    if (!v) return;
    var ce = $('[data-tryon-carterror]');
    ce.hidden = true;
    atc.disabled = true;
    atc.textContent = 'Wird hinzugefügt …';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message);
        close();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && json.sections) { drawer.renderContents(json); } else { window.location.href = '/cart'; }
      })
      .catch(function (e) {
        ce.textContent = e.message || 'Konnte nicht hinzugefügt werden.';
        ce.hidden = false;
        updateAtc();
      });
  });
})();
